import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
var SiteBackground = function(){
	var $section = $("#SiteBackground");
	if( $section.length < 1 ) return false;

	imagesLoaded($section[0], { background: true }, sectionLoaded);

	function sectionLoaded(event) {
		$section.addClass('is-active');
	}
}

export default SiteBackground();